import { createContext, useContext, useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import keycloak from '../auth/keycloak';
import baseapi from '../services/baseapi';
import { showError } from '../utils/toast';
// import { handleLogout } from '../auth/logout';
interface AuthContextType {
  isAuthenticated: boolean;
  isInitialized: boolean;
  keycloak: typeof keycloak;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isInitialized, setIsInitialized] = useState(false);
  const isKeycloakInitialized = useRef(false); // ✅ Prevent double init

  const permissions = async () => {
    try {
      const response = await baseapi('/me')
      if (response.data) {
        localStorage.setItem('user', JSON.stringify(response.data.user))
        localStorage.setItem('ticketing_domain', response.data.user.ticketing_domain)
        localStorage.setItem('permissions', JSON.stringify(response.data.user.permissions))
        localStorage.setItem('client_ids', response.data.user.client_ids)
        localStorage.setItem('request_host', response.data.user.request_host)
      }
      else {
        showError(response.data.message)
      }
    } catch (error: any) {
      // handleLogout()
      showError(error.message)
    }
  }
  useEffect(() => {
    if (isKeycloakInitialized.current) return; // ✅ Skip re-initialization

    const shouldCheckSSO = location.pathname !== '/';

    keycloak
      .init({
        onLoad: shouldCheckSSO ? 'check-sso' : undefined,
        checkLoginIframe: false,
      })
      .then((auth) => {
        isKeycloakInitialized.current = true; // ✅ Mark as initialized

        setIsAuthenticated(auth);

        if (auth) {
          localStorage.setItem('access_token', keycloak.token || '');
          localStorage.setItem('id_token', keycloak.idToken || '');
          if (!localStorage.getItem('level')) {
            localStorage.setItem('level', JSON.stringify({ name: 'global' }));
          }
          setTokenRefresh();
          permissions();
        }

        setIsInitialized(true);
      })
      .catch(() => {
        setIsAuthenticated(false);
        setIsInitialized(true);
      });
  }, []); // ✅ Only run once on mount

  const setTokenRefresh = () => {
    setInterval(() => {
      keycloak
        .updateToken(120)
        .then((refreshed) => {
          if (refreshed) {
            localStorage.setItem('access_token', keycloak.token || '');
            // localStorage.setItem('refresh_token', keycloak.refreshToken || '');
            localStorage.setItem('id_token', keycloak.idToken || '');
            // permissions();

          }
        })
        .catch(() => {
          localStorage.clear();
          keycloak.logout({ redirectUri: window.location.origin });
        });
    }, 60 * 1000);
  };



  return (
    <AuthContext.Provider value={{ isAuthenticated, isInitialized, keycloak }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth must be used within an AuthProvider');
  return context;
};
